import { Wifi, Plus, Trash2 } from "lucide-react";
import { inputCls, labelCls } from "./constants";

export default function InternetPageSection({ pages, setPages }) {
  return (
    <section>
      <h3 className="flex items-center gap-2 font-bold text-slate-800 text-lg mb-4">
        <Wifi size={18} className="text-[#1f3a8a]" /> Podstrona „Internet mobilny”
      </h3>
      <div className="rounded-xl border border-slate-200 p-5 bg-slate-50/50 space-y-4">
        <div className="grid md:grid-cols-3 gap-3">
          <div>
            <label className={labelCls}>Nadtytuł</label>
            <input data-testid="internet-eyebrow" className={inputCls} value={pages.internet.eyebrow} onChange={(e) => setPages({ ...pages, internet: { ...pages.internet, eyebrow: e.target.value } })} />
          </div>
          <div className="md:col-span-2">
            <label className={labelCls}>Nagłówek</label>
            <input data-testid="internet-title" className={inputCls} value={pages.internet.hero_title} onChange={(e) => setPages({ ...pages, internet: { ...pages.internet, hero_title: e.target.value } })} />
          </div>
        </div>
        <div>
          <label className={labelCls}>Podtytuł</label>
          <textarea data-testid="internet-subtitle" className={inputCls} rows={2} value={pages.internet.hero_subtitle} onChange={(e) => setPages({ ...pages, internet: { ...pages.internet, hero_subtitle: e.target.value } })} />
        </div>
        <div>
          <div className="flex items-center justify-between mb-2">
            <label className={labelCls}>Punkty pod ceną każdego pakietu</label>
            <button type="button" data-testid="add-internet-bullet" onClick={() => setPages({ ...pages, internet: { ...pages.internet, bullets: [...pages.internet.bullets, ""] } })} className="inline-flex items-center gap-1 text-sm font-semibold text-[#1f3a8a] hover:text-[#15296b]"><Plus size={14} /> Dodaj</button>
          </div>
          <div className="space-y-2">
            {pages.internet.bullets.map((b, i) => (
              <div key={i} className="flex gap-2">
                <input data-testid={`internet-bullet-${i}`} className={inputCls} value={b} onChange={(e) => setPages({ ...pages, internet: { ...pages.internet, bullets: pages.internet.bullets.map((x, idx) => idx === i ? e.target.value : x) } })} />
                <button type="button" onClick={() => setPages({ ...pages, internet: { ...pages.internet, bullets: pages.internet.bullets.filter((_, idx) => idx !== i) } })} className="text-red-500 hover:text-red-700 px-2"><Trash2 size={16} /></button>
              </div>
            ))}
          </div>
        </div>
        <div>
          <label className={labelCls}>Tekst przycisku „Zamawiam”</label>
          <input data-testid="internet-cta" className={inputCls} value={pages.internet.cta_button} onChange={(e) => setPages({ ...pages, internet: { ...pages.internet, cta_button: e.target.value } })} />
        </div>
        <label className="flex items-center gap-3 p-3 bg-white rounded-lg border border-slate-200 mt-2">
          <input
            data-testid="internet-show-featured"
            type="checkbox"
            checked={pages.internet.show_featured !== false}
            onChange={(e) => setPages({ ...pages, internet: { ...pages.internet, show_featured: e.target.checked } })}
            className="accent-[#1f3a8a] w-5 h-5"
          />
          <div>
            <div className="font-semibold text-slate-800">Pokaż odznakę „Najczęściej wybierany"</div>
            <div className="text-xs text-slate-500">Wyświetla czerwoną odznakę i ramkę wokół środkowego pakietu Internetu mobilnego.</div>
          </div>
        </label>
      </div>
    </section>
  );
}
